<template>
    <div ref="newJobForm" id="newJobForm">

        <div :class="{'error-validation': this.hasErrors.zoneId === true }"
             class="col-md-12 text-center"
        >
            <ZoneSelector
                    v-bind:zoneId="job.address.zoneId"
                    v-on:update:zoneId="job.address.zoneId = $event"
                    v-bind:countryCode="'BE'"
                    v-bind:placeholder="''"
                    :custom-input-class="'full-width'"
            >
            </ZoneSelector>
        </div>

        <div class="col-md-12" :class="{'error-validation': this.hasErrors.lastName === true }">
            <label>
                {{'Please select a job type'|trans}}
            </label>
            <div class="input-group">
                <JobTypeSelectApp  v-on:jobTypeSelected="job.jobTypeId  = $event"></JobTypeSelectApp>
            </div>
        </div>

        <div :class="{'error-validation': this.hasErrors.description === true }"
             class="col-md-12 col-sm-12 col-xs-12 ">
            <label for="description">{{'Description'|trans}}</label>
            <textarea v-model="job.description" id="description" class="form-control"></textarea>
        </div>

        <div :class="{'error-validation': this.hasErrors.timeRequired === true }"
             class="col-md-12 col-sm-12 col-xs-12 ">
            <label for="time-required-for-job">
                <span class="fa fa-clock-o"></span>
                {{'Time Required'|trans}}
            </label>
            <br>
            <div class="btn-group " role="group" id="time-required-for-job">
                <button v-for="time in timeRequiredForJob"
                        @click="job.timeRequired=time.value"
                        :class="{'selected': job.timeRequired === time.value}"
                        type="button" class="btn btn-default">
                    {{time.label}}
                </button>
            </div>
        </div>


        <div class="col-md-12 col-sm-12 col-xs-12 " :class="{'error-validation': this.hasErrors.dateJobStart === true }">
            <label>{{'Suggestions'|trans}}</label>
            <SlotSuggestions v-bind:dataQuery="dataQuery" v-on:slotSelected="job.dateJobStart = $event"></SlotSuggestions>
        </div>


        <!-- Customer Information-->
        <!--******** LASTNAME ********-->
        <div :class="{'error-validation': this.hasErrors.lastName === true }" class="col-md-12 col-sm-12 col-xs-12">
            <label for="last-name">{{'Last Name'|trans}}</label>
            <input v-model="job.customer.lastName" id="last-name" type="text" class="form-control full-width"
                   placeholder="">
        </div>

        <!--******** ADDRESS ********-->
        <div :class="{'error-validation': this.hasErrors.street === true }" class="col-md-8 col-sm-8 col-xs-8 ">
            <label for="street">{{'Street'|trans}}</label>
            <input v-model="job.address.street" id="street" type="text" class="form-control full-width" placeholder="">
        </div>

        <div :class="{'error-validation': this.hasErrors.number === true }"
             class="col-md-4 col-sm-4 col-xs-4 "
        >
            <label for="number">{{'Number'|trans}}</label>
            <input v-model="job.address.number" id="number" type="text" class="form-control full-width"
                   placeholder="">
        </div>

        <!--******** CUSTOMER  ********-->

        <div :class="{'error-validation': this.hasErrors.phone === true }"
             class="col-md-12 col-sm-12 col-xs-12 ">
            <label for="email">{{'Phone Number'|trans}}</label>
            <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-phone"></i> </div>
                <input v-model="job.customer.phone"  class="form-control full-width" id="phone" type="tel" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}">
            </div>
        </div>

        <div :class="{'error-validation': this.hasErrors.email === true || this.hasErrors.emailInvalid === true }"
             class="col-md-8 col-sm-8 col-xs-8 ">
            <label for="email">{{'Email'|trans}}</label>
            <input v-model="job.customer.email" id="email" type="text" class="form-control full-width"
                   placeholder="">
        </div>

        <div :class="{'error-validation': this.hasErrors.language === true }"
             class="col-md-4 col-sm-4 col-xs-4 ">
            <label for="langue">{{'Language'|trans}}</label>
            <select v-model="job.customer.language" class="form-control" id="langue">
                <option :value="'fr'">FR</option>
                <option :value="'nl'">NL</option>
                <option :value="'en'">EN</option>
            </select>
        </div>

        <div class="col-md-12 col-sm-12 col-xs-12 ">
            <button type="submit" class="btn btn-primary full-width" @click="submitForm()">Submit</button>
        </div>

    </div>
</template>

<script>
	import ZoneSelector from "../Zone/ZoneSelector";
	import SlotSuggestions from "../SlotSuggestions/SlotSuggestions";
	import JobType from "../JobType/JobType";
	import JobTypeSelectApp from "../JobType/JobTypeSelectApp";
	export default {
		components: {JobTypeSelectApp, JobType, SlotSuggestions, ZoneSelector},
		props: {
			user: Object,
            job: Object
		},
		data: function () {
			return {
				timeRequiredForJob: [
					{'label': '40min', 'value': 40},
					{'label': '1h00', 'value': 60},
					{'label': '1h20', 'value': 80},
					{'label': '2h00', 'value': 120},
					{'label': '3h00', 'value': 180},
					{'label': '6h00', 'value': 360},
					{'label': '9h00', 'value': 540},
					{'label': '+', 'value': 0},
				],
				hasErrors: {
					description: false,
					timeRequired: false,
					jobTypeId: false,
					lastName: false,
					language: false,
					email: false,
					emailInvalid: false,
					zoneId: false,
					street: false,
					number: false,
					dateJobStart:false
				},
			};
		},
        created() {
		},
		methods:{
			submitForm(){
                if(this.isFormValid()){
                	this.$emit('submit');
                }
            },
			isFormValid() {
				this.checkNullableValuesInForm(this.job);
				this.validateEmail();
				const isValid = !Object.values(this.hasErrors).some(value => value === true);
				if(!isValid){
					this.$refs.newJobForm.scrollTop = this.$refs.newJobForm.scrollHeight;
				}
				return isValid;
			},
			checkNullableValuesInForm(dataObject) {
				for (let obj of Object.keys(dataObject)) {
					if (typeof dataObject[obj] === 'object' && dataObject[obj] !== null) {
						this.checkNullableValuesInForm(dataObject[obj]);
					} else {
						if (dataObject[obj] === null || dataObject[obj] === '') {
							this.hasErrors[obj] = true;
						} else {
							this.hasErrors[obj] = false;
						}
					}
				}
			},
			validateEmail() {
				this.hasErrors.emailInvalid = false; // reset before check;
				if (this.job.customer.email !== null) {
					const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					if (!re.test(this.job.customer.email)) {
						this.hasErrors.emailInvalid = true;
					}
				}
			},
        },
		computed:{
			dataQuery(){
				return {
					interventionAddressZoneId : this.job.address.zoneId,
					leafJobTypeId : this.job.jobTypeId,
					restrictToWorkerId : this.user.user_id,
					durationRequired : this.job.timeRequired,
					interventionType :"'new'"
				}
			}
		},
        filters:{
        }
	}
</script>

